import { StateUtils } from '@spartacus/core';
import { Ticket } from '../../model/ticket.model';
import { TICKETS } from '../custom-tickets-state';

export enum CustomTicketsActionTypes {
  LOAD_TICKETS = '[Tickets] Load Tickets',
  LOAD_TICKETS_SUCCESS = '[Tickets] Load Tickets Success',
  LOAD_TICKETS_FAIL = '[Tickets] Load Tickets Fail',

  LOAD_TICKETS_CATEGORY = '[Tickets] Load Category Tickets',
  LOAD_TICKETS_CATEGORY_SUCCESS = '[Tickets] Load Category Tickets Success',
  LOAD_TICKETS_CATEGORY_FAIL = '[Tickets] Load Category Tickets Fail',

  LOAD_TICKETS_COMPANY_CATEGORY = '[Tickets] Load Company Category Tickets',
  LOAD_TICKETS_COMPANY_CATEGORY_SUCCESS = '[Tickets] Load Company Category Tickets Success',
  LOAD_TICKETS_COMPANY_CATEGORY_FAIL = '[Tickets] Load Company Category Tickets Fail',

  LOAD_TICKET = '[Tickets] Load Ticket',
  LOAD_TICKET_SUCCESS = '[Tickets] Load Ticket Success',
  LOAD_TICKET_FAIL = '[Tickets] Load Ticket Fail',

  ADD_TICKET = '[Tickets] Add Ticket',
  ADD_TICKET_SUCCESS = '[Tickets] Add Ticket Success',
  ADD_TICKET_FAIL = '[Tickets] Add Ticket Fail'
}
export type TicketPage = {
  userId: string;
  pageSize?: number;
  currentPage?: number;
  sort?: string;
};
export class LoadTickets extends StateUtils.LoaderLoadAction {
  readonly type = CustomTicketsActionTypes.LOAD_TICKETS;

  constructor(public payload: TicketPage) {
    super(TICKETS);
  }
}

export class LoadTicketsFail extends StateUtils.LoaderFailAction {
  readonly type = CustomTicketsActionTypes.LOAD_TICKETS_FAIL;

  constructor(public payload: { error: any }) {
    super(TICKETS, payload.error);
  }
}

export class LoadTicketsSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = CustomTicketsActionTypes.LOAD_TICKETS_SUCCESS;

  constructor(public payload: any) {
    super(TICKETS);
  }
}

export class LoadTicketsCategory extends StateUtils.LoaderLoadAction {
  readonly type = CustomTicketsActionTypes.LOAD_TICKETS_CATEGORY;

  constructor() {
    super(TICKETS);
  }
}

export class LoadTicketsCategoryFail extends StateUtils.LoaderFailAction {
  readonly type = CustomTicketsActionTypes.LOAD_TICKETS_CATEGORY_FAIL;

  constructor(public payload: { error: any }) {
    super(TICKETS, payload.error);
  }
}

export class LoadTicketsCategorySuccess extends StateUtils.LoaderSuccessAction {
  readonly type = CustomTicketsActionTypes.LOAD_TICKETS_CATEGORY_SUCCESS;

  constructor(public payload: any) {
    super(TICKETS);
  }
}

export class LoadTicketsCompanyCategory extends StateUtils.LoaderLoadAction {
  readonly type = CustomTicketsActionTypes.LOAD_TICKETS_COMPANY_CATEGORY;

  constructor() {
    super(TICKETS);
  }
}

export class LoadTicketsCompanyCategoryFail extends StateUtils.LoaderFailAction {
  readonly type = CustomTicketsActionTypes.LOAD_TICKETS_COMPANY_CATEGORY_FAIL;

  constructor(public payload: { error: any }) {
    super(TICKETS, payload.error);
  }
}

export class LoadTicketsCompanyCategorySuccess extends StateUtils.LoaderSuccessAction {
  readonly type = CustomTicketsActionTypes.LOAD_TICKETS_COMPANY_CATEGORY_SUCCESS;

  constructor(public payload: any) {
    super(TICKETS);
  }
}

export class LoadTicket extends StateUtils.LoaderLoadAction {
  readonly type = CustomTicketsActionTypes.LOAD_TICKET;

  constructor(public payload: { userId: string; ticketId: string }) {
    super(TICKETS);
  }
}

export class LoadTicketFail extends StateUtils.LoaderFailAction {
  readonly type = CustomTicketsActionTypes.LOAD_TICKET_FAIL;

  constructor(public payload: { error: any }) {
    super(TICKETS, payload.error);
  }
}

export class LoadTicketSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = CustomTicketsActionTypes.LOAD_TICKET_SUCCESS;

  constructor(public payload: any) {
    super(TICKETS);
  }
}

export class AddTicket extends StateUtils.LoaderLoadAction {
  readonly type = CustomTicketsActionTypes.ADD_TICKET;

  constructor(public payload: { userId: string; ticket: Ticket }) {
    super(TICKETS);
  }
}

export class AddTicketFail extends StateUtils.LoaderFailAction {
  readonly type = CustomTicketsActionTypes.ADD_TICKET_FAIL;

  constructor(public payload: { error: any }) {
    super(TICKETS, payload.error);
  }
}

export class AddTicketSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = CustomTicketsActionTypes.ADD_TICKET_SUCCESS;

  constructor(public payload: any) {
    super(TICKETS);
  }
}

// action types
export type CustomTicketsListActions =
  | LoadTickets
  | LoadTicketsFail
  | LoadTicketsSuccess
  | LoadTicket
  | LoadTicketSuccess
  | LoadTicketFail
  | LoadTicketsCategory
  | LoadTicketsCategoryFail
  | LoadTicketsCategorySuccess
  | LoadTicketsCompanyCategory
  | LoadTicketsCompanyCategoryFail
  | LoadTicketsCompanyCategorySuccess
  | AddTicket
  | AddTicketFail
  | AddTicketSuccess;
